(() => {
  const setup = () => {
    document.querySelectorAll('product-card').forEach(card => {
      if (!card.querySelector('a[href*="/products/green-line-team-trinkflasche-750ml"]') || card.dataset.teamReady) return;
      card.dataset.teamReady = 'true';
      card.querySelectorAll('button.quick-add__button').forEach(button => {
        const link = document.createElement('a');
        link.className = button.className;
        const url = new URL('/products/green-line-team-trinkflasche-750ml', location.origin);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if(preview) url.searchParams.set('preview_theme_id',preview);
        link.href = url.toString();link.textContent = 'Größe und Farbe wählen';
        button.replaceWith(link);
      });
    });
    if(location.pathname === '/collections/gym-goods-trinkflaschen') {
      if(document.querySelector('.product-grid__item a[href*="/products/green-line-team-trinkflasche-500ml"]')) document.querySelectorAll('[role="status"]').forEach(el => {const match = el.textContent.trim().match(/^(\d+) Artikel$/);if(match && !el.dataset.teamCounted) {el.textContent = (Number(match[1])-1) + ' Artikel';el.dataset.teamCounted = 'true';}});
      const walker = document.createTreeWalker(document.querySelector('main'),NodeFilter.SHOW_TEXT);
      while(walker.nextNode()) {const node = walker.currentNode;if(node.textContent.includes('Green-Line')) node.textContent = node.textContent.replaceAll('Green-Line','Eurobottle');if(node.textContent.trim() === 'Exklusive Preise nach Login') node.textContent = 'Unbedruckt direkt bestellen';}
    }
  };
  setup();
  document.addEventListener('shopify:section:load',setup);
})();
